import React from "react"

// Authentication
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import UserProfile from "../pages/Authentication/user-profile"

// Landing
import LandingPage from "../pages/LandingPage/index"
import CheckoutPage from "../pages/LandingPage/CheckoutPage"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import ManagerDashboard from "../pages/Dashboard/Manager/index"
import FinancialDashboard from "../pages/Dashboard/Financial/index"

// Admin
import Roles from "../pages/Admin/Roles/index"
import Activities from "../pages/Admin/Activities/index"
import Areas from "../pages/Admin/Areas/index"
import Employees from "../pages/Admin/Employees/index"
import EventsPage from "../pages/Admin/Events/index"
import Levels from "../pages/Admin/Levels/index"
import MembershipsPage from "../pages/Admin/Memberships/index"
import ServicesPage from "../pages/Admin/Services/index"
import BankAccountsPage from "../pages/Admin/BankAccounts/index"
import AcquirersPage from "../pages/Admin/Acquirers/index"
import AuditLogsPage from "../pages/Admin/AuditLogs/index"
import PortfolioPage from "../pages/Admin/Portfolio/index"
import FinancialCategoriesPage from "../pages/Admin/FinancialCategories/index"

// Management
import Classes from "../pages/Management/Classes/index"
import TrialsPage from "../pages/Management/Trials/index"

// Members
import Members from "../pages/Member/index"
import MemberProfile from "../pages/Member/Profile/index"
import SalesPoint from "../pages/Sales/SalesPoint/index"
import DebtPaymentPoint from "../pages/Member/DebtPayment/index"

// Grade
import Grade from "../pages/Grade/index"
import EnrollmentGrade from "../pages/Grade/EnrollmentGrade/index"
import PlanningPage from "../pages/Grade/Planning/index"

// Evaluation
import EvaluationPage from "../pages/Evaluation/index"

// Training
import WorkoutsPage from "../pages/Training/Workouts/index"

// CRM
import CrmPage from "../pages/Crm/index"

// Financial
import CashierPage from "../pages/Financial/Cashier/index"
import ReceivablesPage from "../pages/Financial/Receivables/index"
import PayablesPage from "../pages/Financial/Payables/index"
import CashFlowPage from "../pages/Financial/CashFlow/index"
import DREPage from "../pages/Financial/DRE/index"

// Settings
import CompanySettingsPage from "../pages/Settings/Company/index"
import GamificationSettingsPage from "../pages/Settings/Gamification/index"
import AutomationsPage from "../pages/Settings/Automations/index"
import IntegrationsPage from "../pages/Settings/Integrations/index"
import ImportMembersPage from "../pages/Settings/ImportMembers/index"
import BusinessRulesPage from "../pages/Settings/BusinessRules/index"

// Kiosk
import KioskPage from "../pages/Kiosk/index"
import EvaluationSystem from "../pages/Kiosk/EvaluationSystem"
import TVDisplay from "../pages/Kiosk/TVDisplay"

// Home
import HomePage from "../pages/Home/index"

const userRoutes = [
  { path: "/home", component: <HomePage /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/dashboard/gerencial", component: <ManagerDashboard /> },
  { path: "/dashboard/financeiro", component: <FinancialDashboard /> },

  // Admin
  { path: "/admin/roles", component: <Roles /> },
  { path: "/admin/activities", component: <Activities /> },
  { path: "/admin/areas", component: <Areas /> },
  { path: "/admin/employees", component: <Employees /> },
  { path: "/admin/events", component: <EventsPage /> },
  { path: "/admin/levels", component: <Levels /> },
  { path: "/admin/memberships", component: <MembershipsPage /> },
  { path: "/admin/services", component: <ServicesPage /> },
  { path: "/admin/bank-accounts", component: <BankAccountsPage /> },
  { path: "/admin/acquirers", component: <AcquirersPage /> },
  { path: "/admin/audit-logs", component: <AuditLogsPage /> },
  { path: "/admin/portfolio", component: <PortfolioPage /> },
  { path: "/admin/financial-categories", component: <FinancialCategoriesPage /> },

  // Management
  { path: "/management/classes", component: <Classes /> },
  { path: "/management/trials", component: <TrialsPage /> },

  // Members
  { path: "/members", component: <Members /> },
  { path: "/members/:id", component: <MemberProfile /> },
  { path: "/members/:id/sales-point", component: <SalesPoint /> },
  { path: "/members/:id/debt-payment", component: <DebtPaymentPoint /> },

  // CRM
  { path: "/crm", component: <CrmPage /> },

  // Grade
  { path: "/grade", component: <Grade /> },
  { path: "/grade/enrollment", component: <EnrollmentGrade /> },
  { path: "/grade/planning", component: <PlanningPage /> },

  // Evaluation
  { path: "/evaluation", component: <EvaluationPage /> },

  // Training
  { path: "/training/workouts", component: <WorkoutsPage /> },

  // Financial
  { path: "/financial/cashier", component: <CashierPage /> },
  { path: "/financial/receivables", component: <ReceivablesPage /> },
  { path: "/financial/payables", component: <PayablesPage /> },
  { path: "/financial/cash-flow", component: <CashFlowPage /> },
  { path: "/financial/dre", component: <DREPage /> },

  // Settings
  { path: "/settings/company", component: <CompanySettingsPage /> },
  { path: "/settings/gamification", component: <GamificationSettingsPage /> },
  { path: "/settings/automations", component: <AutomationsPage /> },
  { path: "/settings/integrations", component: <IntegrationsPage /> },
  { path: "/settings/import-members", component: <ImportMembersPage /> },
  { path: "/settings/business-rules", component: <BusinessRulesPage /> },

  // Profile
  { path: "/profile", component: <UserProfile /> },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/checkout", component: <CheckoutPage /> },
  { path: "/", component: <LandingPage /> },
]

const kioskRoutes = [
  { path: "/kiosk", component: <KioskPage /> },
  { path: "/kiosk/evaluation", component: <EvaluationSystem /> },
  { path: "/kiosk/tv", component: <TVDisplay /> },
]

export { userRoutes, authRoutes, kioskRoutes }